import type { ClassificacaoCliente } from '@pgcustom/shared-types';

/** Opções de classificação manual do cliente (ADR 008) — compartilhado entre o formulário e a tabela de listagem para nunca divergir o rótulo exibido. */
export const CLASSIFICACOES_CLIENTE: Array<{ valor: ClassificacaoCliente; rotulo: string }> = [
  { valor: 'padrao', rotulo: 'Padrão' },
  { valor: 'recorrente', rotulo: 'Recorrente' },
  { valor: 'vip', rotulo: 'VIP' },
];

export function rotuloClassificacao(valor: ClassificacaoCliente): string {
  return CLASSIFICACOES_CLIENTE.find((opcao) => opcao.valor === valor)?.rotulo ?? valor;
}
